
import { Component, Vue } from "vue-property-decorator";
import * as Model from "@gigalot/data-models";
const lodash = require("lodash");
import { EventBus } from "../eventBus";
const Subscriber = require("@jetblack/graphql-reconnect-client");
import { createClient } from "@/helpers/graphql-ws-rtc-adapter";
import { DimssaButton, ButtonState } from "@/components/shared/dimssa-button.vue";

@Component({
  components: {
    DimssaButton,
  },
})
export default class VehicleSummary extends Vue {
  name = "vehicleSummary";
  vehicleSummary: any[] = [];
  loading = false;
  scheduleItems: any = [];
  mixingScheduledItems: any = [];
  mixResults: any = [];

  headers = [
    {
      text: "Vehicle",
      value: "vehicleId",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Driver",
      value: "driver",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Ration",
      value: "ration",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Status",
      value: "status",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Wagon Mass",
      value: "wagonMass",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Job Amount",
      value: "jobAmount",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Last Kraal",
      value: "lastKraal",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Next Kraal",
      value: "nextKraal",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Last Comms",
      value: "lastCommsTime",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
  ];

  feedSchedules = [];
  urlws = "wss://pi.gigalot.systems:7778/api/ws";
  options = {};

  graphQLSubscriber: any = undefined;
  graphQLUnsubscribe: any = undefined;

  subscriptions = `subscription($guid:String!){
        vehicleSummary(guid:$guid){
          typename
          vehicleId
          driver
          ration
          status
          wagonMass
          jobAmount
          lastKraal
          nextKraal
          lastCommsTime
    }
      }`;

  variables = { guid: this.$store.state.user.location.guid };
  operationName = null;

  mounted() {
    this.$store.dispatch("user/addFirebaseCallback", this.getData);
    this.$store.dispatch("user/addFirebaseCallback", this.getDataSocket);
  }

  get moment() {
    return this.$store.state.moment;
  }

  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }
  destroyed() {
    if (this.graphQLUnsubscribe) {
      this.graphQLUnsubscribe();
    }
    if (this.graphQLSubscriber) {
      this.graphQLSubscriber();
    }
  }

  numberWithCommas(x: number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  async getData() {
    try {
      console.log("VehicleSummary()");
      this.loading = true;
      let gql = `query($guid:String!){
        VehicleSummary(guid:$guid){
          typename
          vehicleId
          driver
          ration
          status
          wagonMass
          jobAmount
          lastKraal
          nextKraal
          lastCommsTime
    }
      }`;

      let json = await this.$store.dispatch("graphQl", { gql, variables: { guid: this.$store.state.user.location.guid } });
      this.vehicleSummary = json.data.VehicleSummary;
    } catch (err) {
      console.log("getVehicleSummary -> error: " + err);
    }
    this.loading = false;

    EventBus.$emit("component-a-done");
  }

  async getDataSocket() {
    if (this.$store.state.useP2PConn) {
      await this.getOnlineFeedDeliveriesSocket();
    } else {
      await this.getOnsiteFeedDeliveriesSocket();
    }
  }

  async getOnlineFeedDeliveriesSocket() {
    let variables = { guid: this.$store.state.user.location.guid, user: this.$store.state.user.user.uid };

    const subscribe = (subscriptions: string, variables: any, callback: (error: any, data: any) => Promise<void>) => {
      const client = createClient();
      let unsubscribe = client?.subscribe(
        {
          query: subscriptions,
          variables: variables,
        },
        {
          next: (message: any) => callback(undefined, message.data),
          error: (err: any) => {
            throw err;
          },
          complete: () => console.log("subscription completed"),
        }
      );
      return unsubscribe;
    };

    this.graphQLUnsubscribe = subscribe(this.subscriptions, variables, async (error: any, data: any) => {
      this.$store.state.wsConnected = true;
      if (!(error || subscribe)) {
        console.log("subscribe success");
        this.$store.state.wsDialogVisible = false;
        // Normal closure
        return;
      }
      if (error) {
        console.log("error subscribing");

        this.$store.state.wsConnected = false;
        if (error.event.type === "close") {
        } else {
          this.$store.state.wsDialogVisible = true;
          console.error(error);
          //    throw error;
        }
      }
      this.$store.state.wsDialogVisible = false;
      this.$store.state.wsConnected = true;
      console.log("almost there");
      this.vehicleSummary = data.vehicleSummary;
    });
  }

  async getOnsiteFeedDeliveriesSocket() {
    this.graphQLSubscriber = Subscriber.graphQLReconnectingSubscriber(
      this.urlws,
      this.options,
      (error: any, subscribe: any) => {
        try {
          if (!(error || subscribe)) {
            console.log("connected to socket");
            this.$store.state.wsDialogVisible = false;
            return;
          }
          if (error) {
            console.log("error connecting to socket");
            if (error.event.type === "close") {
            } else {
              this.$store.state.wsDialogVisible = true;
              console.error(error);
            }
          }
          console.log("socket connected");
          this.graphQLUnsubscribe = subscribe(this.subscriptions, this.variables, this.operationName, (error: any, data: any) => {
            if (!(error || subscribe)) {
              console.log("subscribe success");
              this.$store.state.wsDialogVisible = false;
              return;
            }
            if (error) {
              console.log("error subscribing");
              if (error.event.type === "close") {
              } else {
                this.$store.state.wsDialogVisible = true;
                console.error(error);
              }
            }
            this.$store.state.wsDialogVisible = false;
            console.log("receiving data");
            this.vehicleSummary = data.vehicleSummary;
            this.loading = false;
          });
        } catch (err) {}
      },
      15000,
      3,
      "graphql-ws"
    );
  }
}
